import client from 'providers/fetchClient'

export const redefinePassword = data => client.post('/users/redefine-password', data)
